import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

interface IdNamePair {
    id: string;
    name: string;
}

export interface SystemAssociatedAssetsCreationFieldProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    errorText?: string;
    disabled: boolean;
}

function SystemAssociatedAssetsCreationField(props: SystemAssociatedAssetsCreationFieldProps) {
    const { translateString } = useTranslation();
    const { data, isLoading } = useDotLegalQueryWithKey<Array<IdNamePair>>("selectableSystemRelations", "/system/selectableRelations");

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={data}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={translateString("associatedAssets")}
            label={translateString("associatedAssets")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemAssociatedAssetsCreationField;
